import axiosInstance from "../api/axiosInstance";

export async function getBranding() {
  const host = window.location.hostname;

  try {
    const response = await axiosInstance.get(`/tennant?host=${host}`);

    return response.data;
  } catch (error) {
    console.error("Branding konnte nicht geladen werden:", error);
    throw new Error("Branding konnte nicht geladen werden");
  }
}